module.exports = __webpack_public_path__ + "static/media/YF47_3.eca647ec.jpg";